import { Component, Input, OnInit } from "@angular/core";
import { SvgService } from "@shared/services/svg.service";

@Component({
  selector: "app-svg-icon",
  standalone: true,
  templateUrl: "svg-icons.component.html",
})
export class SvgIconComponent implements OnInit {
  @Input() src!: string;
  svgContent: any;

  constructor(private readonly svgService: SvgService) {}

  ngOnInit() {
    if (this.src) {
      this.svgService.getSvg(this.src).subscribe(svg => {
        this.svgContent = svg;
      });
    }
  }
}
